import emailjs from 'emailjs-com';

export async function SendEmailInterest(data: any) {
    return emailjs.send('gmail', 'interest_12345', MapBoolsToStringsEmailInterest(data), 'user_lTzrbCvQo4FJtFtcQwBu2')
}

export async function SendEmailError(data: any) {
    return emailjs.send('gmail', 'template_Pb63Hhsm', MapBoolsToStringsEmailError(data), 'user_lTzrbCvQo4FJtFtcQwBu2')
}

function MapBoolsToStringsEmailInterest(data: any){
    data.animals = data.animals === true ? "Ja" : "Nej";
    data.smoking = data.smoking === true ? "Ja" : "Nej";
    return data;
}

function MapBoolsToStringsEmailError(data: any){
    data.allowingEntry = data.allowingEntry === true ? "Ja" : "Nej";
    return data;
}